export const getListLocalization = (list, formatMessage) => {
  if (!list) return false;
  return list.map(item => {
    let label;
    const id = item.label;

    if (formatMessage) {
      label = formatMessage({ id });
    }

    return {
      value: item.value,
      label,
    };
  });
};



// WEBPACK FOOTER //
// ./src/utils/converters/getListLocalization.js